var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackageCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 82,
    viewBox: "0 0 79 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.151 56.5965L60.9516 64.397L76.5527 48.7959",
    stroke: "#32BA38",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6524 33.1943V25.3937C72.651 24.0258 72.2899 22.6823 71.6053 21.498C70.9207 20.3136 69.9367 19.3302 68.7521 18.6462L41.4501 3.04508C40.2643 2.36043 38.9191 2 37.5498 2C36.1805 2 34.8354 2.36043 33.6495 3.04508L6.34755 18.6462C5.16289 19.3302 4.17891 20.3136 3.49434 21.498C2.80977 22.6823 2.44867 24.0258 2.44727 25.3937V56.596C2.44867 57.9639 2.80977 59.3074 3.49434 60.4917C4.17891 61.676 5.16289 62.6595 6.34755 63.3435L33.6495 78.9446C34.8354 79.6292 36.1805 79.9897 37.5498 79.9897C38.9191 79.9897 40.2643 79.6292 41.4501 78.9446L49.2507 74.4983",
    stroke: "#32BA38",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1013 30.855L20.1937 10.7295",
    stroke: "#32BA38",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.55 40.9956V79.9984M3.57849 21.4941L37.55 40.9956L3.57849 21.4941ZM37.55 40.9956L71.5214 21.4941L37.55 40.9956Z",
    stroke: "#32BA38",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageCheck);
export default __webpack_public_path__ + "static/media/package-check.04f47c98884b3f08094c64f88ce894ff.svg";
export { ForwardRef as ReactComponent };